/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated with ApiClientGenerator, using the NSwag toolchain
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import axios, { AxiosRequestConfig, AxiosPromise, CancelToken, AxiosInstance } from 'axios';
import { injectable, inject, optional, symbolToken } from '@servicetitan/react-ioc';
import { makeCodedException, makeContent } from 'utils';
// @ts-ignore: needed for Date serialization if a DateTime parameter has an Unspecified attribute on it
import moment from 'moment';

export interface IPortalInvoices {
    getAll(
        membershipIds: number[] | undefined,
        invoiceFilterFlags: number | null | undefined,
        cancelToken?: CancelToken
    ): AxiosPromise<InvoiceV2[]>;
    searchInvoices(
        searchRequest: InvoiceSearchRequest,
        cancelToken?: CancelToken
    ): AxiosPromise<InvoiceSearchResult>;
    get(id: string, cancelToken?: CancelToken): AxiosPromise<InvoiceV2>;
    getConsolidatedInvoice(id: string, cancelToken?: CancelToken): AxiosPromise<InvoiceV2>;
    dashboard(cancelToken?: CancelToken): AxiosPromise<DashboardCustomerInvoicesModel[]>;
    getConsolidatedTargetInvoiceBalances(
        consolidatedInvoiceIds: string[],
        cancelToken?: CancelToken
    ): AxiosPromise<InvoiceV2[]>;
    getInvoicePreview(id: string, cancelToken?: CancelToken): AxiosPromise<FileResponse>;
    getInvoicePdfStream(id: string, cancelToken?: CancelToken): AxiosPromise<FileResponse>;
    getConsolidatedInvoicePdfStream(
        id: string,
        cancelToken?: CancelToken
    ): AxiosPromise<FileResponse>;
    getServiceAgreementNameAndJobNumber(
        id: string,
        cancelToken?: CancelToken
    ): AxiosPromise<ServiceAgreementNameAndJobNumberForInvoice>;
}

export const BASE_URL_TOKEN_PortalInvoices = symbolToken<string>('BASE_URL_TOKEN', false);

@injectable()
export class PortalInvoices implements IPortalInvoices {
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(private readonly axios: AxiosInstance, private readonly baseUrl = '') {}

    getAll(
        membershipIds: number[] | undefined,
        invoiceFilterFlags: number | null | undefined,
        cancelToken?: CancelToken
    ): AxiosPromise<InvoiceV2[]> {
        let url_ = '/v1/customerportal2/invoices?';
        if (membershipIds === null)
            throw new Error("The parameter 'membershipIds' cannot be null.");
        else if (membershipIds !== undefined)
            membershipIds &&
                membershipIds.forEach(item => {
                    url_ += 'membershipIds=' + encodeURIComponent('' + item) + '&';
                });
        if (invoiceFilterFlags !== undefined && invoiceFilterFlags !== null)
            url_ += 'invoiceFilterFlags=' + encodeURIComponent('' + invoiceFilterFlags) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            url: url_,
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            },
        };

        return makeCodedException(this.axios.request<InvoiceV2[]>(options_));
    }

    searchInvoices(
        searchRequest: InvoiceSearchRequest,
        cancelToken?: CancelToken
    ): AxiosPromise<InvoiceSearchResult> {
        let url_ = '/v1/customerportal2/invoices/search';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = searchRequest;

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            data: content_,
            url: url_,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            },
        };

        return makeCodedException(this.axios.request<InvoiceSearchResult>(options_));
    }

    get(id: string, cancelToken?: CancelToken): AxiosPromise<InvoiceV2> {
        let url_ = '/v1/customerportal2/invoices/{id}';
        if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace('{id}', encodeURIComponent('' + id));
        url_ = url_.replace(/[?&]$/, '');

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            url: url_,
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            },
        };

        return makeCodedException(this.axios.request<InvoiceV2>(options_));
    }

    getConsolidatedInvoice(id: string, cancelToken?: CancelToken): AxiosPromise<InvoiceV2> {
        let url_ = '/v1/customerportal2/invoices/consolidatedInvoice/{id}';
        if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace('{id}', encodeURIComponent('' + id));
        url_ = url_.replace(/[?&]$/, '');

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            url: url_,
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            },
        };

        return makeCodedException(this.axios.request<InvoiceV2>(options_));
    }

    dashboard(cancelToken?: CancelToken): AxiosPromise<DashboardCustomerInvoicesModel[]> {
        let url_ = '/v1/customerportal2/invoices/dashboard';
        url_ = url_.replace(/[?&]$/, '');

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            url: url_,
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            },
        };

        return makeCodedException(this.axios.request<DashboardCustomerInvoicesModel[]>(options_));
    }

    getConsolidatedTargetInvoiceBalances(
        consolidatedInvoiceIds: string[],
        cancelToken?: CancelToken
    ): AxiosPromise<InvoiceV2[]> {
        let url_ = '/v1/customerportal2/invoices/targetInvoiceBalances';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = consolidatedInvoiceIds;

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            data: content_,
            url: url_,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            },
        };

        return makeCodedException(this.axios.request<InvoiceV2[]>(options_));
    }

    getInvoicePreview(id: string, cancelToken?: CancelToken): AxiosPromise<FileResponse> {
        let url_ = '/v1/customerportal2/invoices/preview/{id}';
        if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace('{id}', encodeURIComponent('' + id));
        url_ = url_.replace(/[?&]$/, '');

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            responseType: 'blob',
            url: url_,
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            },
        };

        return makeCodedException(this.axios.request<FileResponse>(options_));
    }

    getInvoicePdfStream(id: string, cancelToken?: CancelToken): AxiosPromise<FileResponse> {
        let url_ = '/v1/customerportal2/invoices/download/{id}';
        if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace('{id}', encodeURIComponent('' + id));
        url_ = url_.replace(/[?&]$/, '');

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            responseType: 'blob',
            url: url_,
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            },
        };

        return makeCodedException(this.axios.request<FileResponse>(options_));
    }

    getConsolidatedInvoicePdfStream(
        id: string,
        cancelToken?: CancelToken
    ): AxiosPromise<FileResponse> {
        let url_ = '/v1/customerportal2/invoices/consolidatedInvoice/download/{id}';
        if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace('{id}', encodeURIComponent('' + id));
        url_ = url_.replace(/[?&]$/, '');

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            responseType: 'blob',
            url: url_,
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            },
        };

        return makeCodedException(this.axios.request<FileResponse>(options_));
    }

    getServiceAgreementNameAndJobNumber(
        id: string,
        cancelToken?: CancelToken
    ): AxiosPromise<ServiceAgreementNameAndJobNumberForInvoice> {
        let url_ = '/v1/customerportal2/invoices/{id}/getServiceAgreementNameAndJobNumber';
        if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace('{id}', encodeURIComponent('' + id));
        url_ = url_.replace(/[?&]$/, '');

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            url: url_,
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            },
        };

        return makeCodedException(
            this.axios.request<ServiceAgreementNameAndJobNumberForInvoice>(options_)
        );
    }
}

export interface InvoiceV2 {
    id: string;
    balance: number;
    billingDate?: Date | undefined;
    invoiceDate?: Date | undefined;
    dueDate?: Date | undefined;
    serviceDate?: Date | undefined;
    items: InvoiceItem[];
    customerId: number;
    encryptedCustomerId: string;
    number: string;
    address: AddressV2;
    summary: string;
    payments?: Payment[] | undefined;
    paymentTotal: number;
    subtotal: number;
    tax?: number | undefined;
    total: number;
    creditCardDisabled: boolean;
    achDisabled: boolean;
    multiplePaymentOptionsEnabled: boolean;
    partialPaymentDisabled: boolean;
    usePaymentGateway: boolean;
    paymentGatewayBaseUrl: string;
    paymentGatewayApiKey: string;
    downloadLinkEnabled: boolean;
    memberSavings?: MemberSavingsModel | undefined;
    serviceAddressName: string;
    serviceLocationId?: number | undefined;
    /** Indicates whether this invoice model represents a Consolidated Invoice entity. */
    isConsolidatedInvoice: boolean;
    /** The collection of distinct service addresses of the Consolidated Invoice. */
    consolidatedInvoiceAddresses?: AddressV2[] | undefined;
    /** The collection of distinct service dates of the Consolidated Invoice. */
    consolidatedInvoiceServiceDates?: Date[] | undefined;
    payByBankDisabled: boolean;
    /**
     * True if Affirm BNPL is not available for this invoice. Mirrors the field added to the
     * backend Invoice DTO in PMT-9129 — kept in sync with the MFE-side type at
     * Clients/mfe/packages/invoices/src/api/portal-invoices.api.ts. Optional for
     * backward-compatibility with object literals from before the field existed.
     */
    affirmDisabled?: boolean | undefined;
}

export interface InvoiceItem {
    id: number;
    code?: string | undefined;
    description?: string | undefined;
    order: number;
    quantity: number;
    total?: number | undefined;
    unitPrice?: number | undefined;
    standardPrice?: number | undefined;
    itemGroupRootId: number;
}

export interface AddressV2 {
    city?: string | undefined;
    state?: string | undefined;
    streetAddress?: string | undefined;
    zip?: string | undefined;
    unit?: string | undefined;
}

export interface Payment {
    amount: number;
    paidOn: Date;
    type?: string | undefined;
}

export interface MemberSavingsModel {
    potentialSavings?: PotentialSavingsModel | undefined;
    actualSavings?: ActualSavingsModel | undefined;
}

export interface PotentialSavingsModel {
    maximumPotentialSavings: number;
    minimumPotentialSavings: number;
}

export interface ActualSavingsModel {
    totalMemberSavings: number;
}

export interface InvoiceSearchResult {
    /** The field by which the results are sorted */
    orderBy: InvoiceSearchSortField;
    /** The sort order */
    orderByDesc: boolean;
    /** The page size */
    pageSize: number;
    /** The page number */
    pageNumber: number;
    /** Indicates if more data pages exist */
    hasMore: boolean;
    /** The total count of invoices that match the search criteria */
    totalCount?: number | undefined;
    /** The search result models */
    invoices?: InvoiceV2[] | undefined;
}

export enum InvoiceSearchSortField {
    DueDate = 0,
    Total = 1,
    Balance = 2,
}

export interface InvoiceSearchRequest {
    invoiceNumber?: string | undefined;
    customerId?: number | undefined;
    serviceLocationIds?: number[] | undefined;
    membershipIds?: number[] | undefined;
    customerPortalInvoiceFilter?: CustomerPortalInvoiceFilter | undefined;
    showMode: InvoiceSearchShowMode;
    paidStatus: InvoiceSearchPaidStatus;
    invoiceDateMin?: Date | undefined;
    invoiceDateMax?: Date | undefined;
    dueDateMin?: Date | undefined;
    dueDateMax?: Date | undefined;
    serviceDateMin?: Date | undefined;
    serviceDateMax?: Date | undefined;
    paymentMethod: InvoiceSearchPaymentMethod;
    orderBy: InvoiceSearchSortField;
    orderByDesc: boolean;
    pageNumber: number;
    pageSize: number;
    includeTotalCount: boolean;
}

export enum CustomerPortalInvoiceFilter {
    None = 0,
    Pending = 1,
    Posted = 2,
    Exported = 4,
    NeedsReview = 8,
    ReviewOnHold = 16,
    Reviewed = 32,
    All = 63,
}

export enum InvoiceSearchShowMode {
    Unpaid = 0,
    Paid = 1,
}

export enum InvoiceSearchPaidStatus {
    Any = 0,
    PastDue = 1,
    PartiallyPaid = 2,
}

export enum InvoiceSearchPaymentMethod {
    Any = 0,
    CreditCard = 1,
    Ach = 2,
    Online = 3,
    NoOnline = 4,
}

export interface DashboardCustomerInvoicesModel {
    id: number;
    name?: string | undefined;
    address?: AddressModel | undefined;
    invoices?: DashboardInvoiceModel[] | undefined;
}

export interface AddressModel {
    street?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zip?: string | undefined;
    unit?: string | undefined;
}

export interface DashboardInvoiceModel {
    id?: string | undefined;
    locationId?: number | undefined;
    totalBalanceDue: number;
}

export interface ServiceAgreementNameAndJobNumberForInvoice {
    serviceAgreementName?: string | undefined;
    jobNumber?: string | undefined;
}

export type FileResponse = Blob;
